var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.18329 9.68332L10.2958 5.57082L9.47913 4.75416L6.18329 8.04999L4.52079 6.38749L3.70413 7.20416L6.18329 9.68332ZM6.99996 12.8333C6.19302 12.8333 5.43468 12.6802 4.72496 12.3739C4.01524 12.0677 3.39788 11.6521 2.87288 11.1271C2.34788 10.6021 1.93225 9.98471 1.626 9.27499C1.31975 8.56527 1.16663 7.80693 1.16663 6.99999C1.16663 6.19305 1.31975 5.43471 1.626 4.72499C1.93225 4.01527 2.34788 3.39791 2.87288 2.87291C3.39788 2.34791 4.01524 1.93228 4.72496 1.62603C5.43468 1.31978 6.19302 1.16666 6.99996 1.16666C7.8069 1.16666 8.56524 1.31978 9.27496 1.62603C9.98468 1.93228 10.602 2.34791 11.127 2.87291C11.652 3.39791 12.0677 4.01527 12.3739 4.72499C12.6802 5.43471 12.8333 6.19305 12.8333 6.99999C12.8333 7.80693 12.6802 8.56527 12.3739 9.27499C12.0677 9.98471 11.652 10.6021 11.127 11.1271C10.602 11.6521 9.98468 12.0677 9.27496 12.3739C8.56524 12.6802 7.8069 12.8333 6.99996 12.8333Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckRed);
export default __webpack_public_path__ + "static/media/check-red.59c7cffe4c43ed3fe44ea4d657b23f38.svg";
export { ForwardRef as ReactComponent };